export default "__VITE_ASSET__9a175aba__"